export const prospectQueryKeys = {
	all: ['prospectQueries'],
	list: () => ['prospectQueries', 'list'],
	withTypes: (page, limit) => ['prospectQueries', 'withTypes', { page, limit }],
	filtered: (queryTypeCodes = null, page = null, limit = null) => [
		'prospectQueries',
		'filtered',
		{ queryTypeCodes: queryTypeCodes?.sort(), page, limit },
	],
	// Live HR match-count preview, keyed by the (debounced) backend search params.
	hrMatchCount: (searchParameters) => ['prospectQueries', 'hrMatchCount', searchParameters],
	// Free-text industry terms → WZ codes, keyed by the parsed term list.
	resolveIndustry: (industrySearchTerms) => ['prospectQueries', 'resolveIndustry', industrySearchTerms],
	// Geocoding lookup for the radius map, keyed by (debounced) location + country.
	geocode: (location, country) => ['prospectQueries', 'geocode', { location, country }],
};

export const prospectQueryMutationKeys = {
	unifiedSearch: ['prospectQueries', 'unifiedSearch'],
	agenticSearch: ['prospectQueries', 'agenticSearch'],
	create: ['prospectQueries', 'create'],
	update: ['prospectQueries', 'update'],
	delete: ['prospectQueries', 'delete'],
	exportCSV: ['prospectQueries', 'exportCSV'],
	merge: ['prospectQueries', 'merge'],
};
